module.exports = __webpack_public_path__ + "static/img/10110658f6fw.a55ab2e7.jpg";